var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"d-flex align-center",attrs:{"to":{ name: 'home' }}},[_c('span',{class:_vm.noText ? 'd-none' : 'ml-1 d-inline'},[_vm._v("Edwork")])])
}
var staticRenderFns = []

export { render, staticRenderFns }